<div class="container">
  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:0px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <br>
    <h2>LOS Rates Report</h2>
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=true [showBedrooms]=true [showSeasons]=false [showStartDate]=true
    [showEndDate]=true (doSearchCB)="onSearchSubmit($event)"></app-search-template>
    <br><br>

    <mat-dialog-content>
      <p-table #dt [value]="rateDetailLosRows" [columns]="scrollingColumns" [frozenColumns]="frozenColumns"
        frozenWidth="100px" [scrollable]="true" scrollHeight="100%" sortMode="multiple" [loading]="formLoading"
        [ngStyle]="{'height':'100%'}">

        <ng-template pTemplate="frozencolgroup" let-columns>
          <colgroup>
          <col style="width:100px">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
        @for (col of columns; track col) {
          <col style="width:75px;">
        }
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th style="height:100px;padding: .2em .2em !important;"
            [pSortableColumn]="col.field">
            {{col.header}}
            <div>@if (col.field === 'checkInDate') {
              <input (click)="clickOnFilter($event)" style="width:50px"
                pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
            }
          </div>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      @for (col of columns; track col) {
        <td style="height:50px; padding: .2em .2em !important;"
          [style.background-color]="getOccupiedBackgroundColor(rowData[col.field],col.field)">
          @if (col.field === 'checkInDate') {
            <span>
              {{rowData[col.field]}}
            </span>
          }
          @if (col.field!='checkInDate' && rowData[col.field]) {
            <span>
              <!-- <span style="color:grey" (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId)">{{rowData[col.field].defaultRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span><br> -->
              <span style="color:black"
                (click)="onOpenRateBucketDetailEdit(rowData[col.field].rateBucketDetailId)">{{rowData[col.field].ttlNightlyRate/(col.field+1) | currency : 'USD' : 'symbol' : '1.0-0'}}<br>
              </span>
              <!-- <span style="color:grey">{{rowData[col.field].ttlNightlyRate | currency : 'USD' : 'symbol' : '1.0-0'}}</span> -->
              <span style="color:blue">{{col.field+1}}</span>&nbsp;
              <span style="color:grey">{{rowData[col.field].checkOutDate | date:'M/d' }}</span>
            </span>
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
</mat-dialog-content>
</div>
